import { FC, useEffect, useState } from "react";
import { ProjectDataButton } from "../ProjectsDataButton";
import { VerticalStack } from "../../../components/Stack";
import { IStackStyles, Text } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { functionalityState } from "../../redux/DocumentStackSlice";
import { colorPallete } from "../../../assets/color";
import "./index.css";
import useIsSignedIn from "../../../hooks/useIsSignedIn";
import { ProjectService } from "../../../services/ProjectService";
import { formatMoney, formatFullMoney } from "../../../utils";

const verticalStackStyles: IStackStyles = {
  root: {
    minHeight: "9rem",
    width: "100%",
    backgroundColor: "",
    justifyContent: "space-evenly",
  },
};

interface PipelineItemProps {
  title: string;
  value: string | number;
}
const PipelineItem: FC<PipelineItemProps> = ({
  title,
  value,
}: PipelineItemProps) => {
  return (
    <div
      style={{
        border: "1px solid grey",
        borderRadius: "0.4rem",
        height: "90px",
        padding: "8px 0px",
        width: "150px",
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          borderBottom: "1px solid grey",
          textAlign: "center",
          color: "grey",
          fontWeight: "bolder",
        }}
      >
        {title}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "xx-large",
        }}
      >
        {value}
      </div>
    </div>
  );
};
interface PipelineProps {
  items: PipelineItemProps[];
}
const Pipeline: FC<PipelineProps> = ({ items }: PipelineProps) => {
  return (
    <div style={{ width: "fit-content", padding: "8px", alignSelf: "center" }}>
      <div
        style={{
          height: "20%",
          textAlign: "center",
          marginBottom: "4px",
          fontSize: "x-large",
        }}
      >
        My Pipeline
      </div>
      <div style={{ display: "flex", gap: "10px" }}>
        {items.map((item, index) => {
          return (
            <PipelineItem key={index} title={item.title} value={item.value} />
          );
        })}
      </div>
    </div>
  );
};
const demoItem = [
  {
    title: "Active",
    value: 1000,
  },
  {
    title: "Closed",
    value: 1000,
  },
  {
    title: "Value",
    value: "$1.4B",
  },
];
export const ProjectDataButtonStack: FC = () => {
  const [activeState, setActiveState] = useState(false);

  const click2 = () => {
    setActiveState(!activeState);
  };
  const dispatch = useDispatch();
  function click() {
    dispatch(functionalityState("draft"));
  }

  function click1() {
    // dispatch(functionalityState("negotiate"));
  }
  const { t } = useTranslation();
  const [statuses, setStatuses] = useState([
    "All Projects - 0 - $0.00",
    "Active - 0 - $0.00",
    "Closed - 0 - $0.00",
  ]);
  const [rawValues, setRawValues] = useState([0, 0, 0]);
  const isSignedIn = useIsSignedIn();
  useEffect(() => {
    const fetchStatuses = async () => {
      try {
        if (isSignedIn) {
          const currentStatus: any = await ProjectService.getStatuses();
          const totalValue = currentStatus.data.closedValue + currentStatus.data.activeValue;
          setRawValues([totalValue, currentStatus.data.activeValue, currentStatus.data.closedValue]);
          setStatuses([
            `All Projects - ${
              currentStatus.data.activeCount + currentStatus.data.closedCount
            } -  ${
              currentStatus.data.closedValue +
                currentStatus.data.activeValue ===
              0
                ? "$0.00"
                : formatMoney(
                    currentStatus.data.closedValue +
                      currentStatus.data.activeValue
                  )
            }`,
            `Active - ${currentStatus.data.activeCount} -  ${formatMoney(
              currentStatus.data.activeValue
            )}`,
            `Closed   - ${currentStatus.data.closedCount} -  ${formatMoney(
              currentStatus.data.closedValue
            )}`,
          ]);
        } else {
          setStatuses([
            "All Projects - 0 - $0.00",
            "Active - 0 - $0.00",
            "Closed - 0 - $0.00",
          ]);
        }
      } catch (error) {
        console.error("Error fetching statuses:", error);
      }
    };

    fetchStatuses();
  }, [isSignedIn]);

  return (
    <VerticalStack styles={verticalStackStyles}>
      <div className="ButtonStack">
        <ProjectDataButton
          buttonText={statuses[0]}
          color={colorPallete.white}
          onClickFunction={click}
          flex={"1 1 30vw"}
          icon="draft"
          borderColor={colorPallete.btBlue}
          hoverColor={"#EFF2F8"}
          tooltipValue={formatFullMoney(rawValues[0])}
        />
        <ProjectDataButton
          buttonText={statuses[1]}
          color={colorPallete.white}
          onClickFunction={click1}
          flex={"1 1 30vw"}
          icon="negotiate"
          borderColor={colorPallete.btGreen}
          hoverColor={"#E7EFE6"}
          tooltipValue={formatFullMoney(rawValues[1])}
        />
        <ProjectDataButton
          buttonText={statuses[2]}
          color={colorPallete.white}
          onClickFunction={click2}
          flex={"1 1 30vw"}
          icon="sign"
          borderColor={colorPallete.btRed}
          hoverColor={"#FCF0ED"}
          tooltipValue={formatFullMoney(rawValues[2])}
        />
      </div>
    </VerticalStack>
  );
};
